import React, {useState, useCallback, useEffect} from "react";

const POSTCODE_UPDATED_EVENT = "postcode-update__postcode-updated";

const PostCodeUpdate = ({ children, onUpdate }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [postCodeUpdateElement, setPostCodeUpdateElement] = useState();


  const postCodeUpdateRef = useCallback(element => {
    if (element !== null) {
      setPostCodeUpdateElement(element);
      element.focus();
    }
  }, []);

  const handleShowPopup = useCallback(() => {
    setShowPopup(true);
  }, []);

  const handleClosePopup = useCallback(() => {
    setShowPopup(false);
  }, []);

  const handleSetLocation = useCallback(event => {
    event.preventDefault();

    if (postCodeUpdateElement) {
      postCodeUpdateElement.triggerPostcodeUpdate();
    }
  }, [showPopup, postCodeUpdateElement]);


  useEffect(() => {
    let shouldUpdateState = true;

    const handlePostCodeUpdateEvent = event => {
      if (shouldUpdateState) {
        setShowPopup(false);
      }

      if (event && event.detail && event.detail.postcode) {
        onUpdate({ postCode: event.detail.postcode.postCode });
      }
    };

    if (postCodeUpdateElement) {
      postCodeUpdateElement.addEventListener(POSTCODE_UPDATED_EVENT, handlePostCodeUpdateEvent);
    }

    return () => {
      shouldUpdateState = false;

      if (postCodeUpdateElement) {
        postCodeUpdateElement.removeEventListener(POSTCODE_UPDATED_EVENT, handlePostCodeUpdateEvent);
      }
    };
  }, [showPopup, postCodeUpdateElement]);

  useEffect(() => {
    if (showPopup) {
      document.body.classList.add('overlay-active');
    } else {
      document.body.classList.remove('overlay-active');
    }

    return () => {
      document.body.classList.remove('overlay-active');
    };
  }, [showPopup]);

  return (
    <React.Fragment>
      <a className="postcode-link" onClick={handleShowPopup}>
        {children || "Enter your postcode to see pricing"}
      </a>

      {showPopup && (
        <div className="popup-postcode-wrapper">
          <a className="popup-postcode-close" onClick={handleClosePopup} />

          <div className="popup-postcode">
            <form action="#" className="popup-postcode__form">
              <div className="popup-postcode__form-row">
                <label className="popup-postcode__label" htmlFor="postcode">Enter your postcode to see pricing</label>
              </div>
              <div className="popup-postcode__form-row">
                <div className="popup-postcode__search-input-container store-finder-container">
                  <postcode-update
                    ref={postCodeUpdateRef}
                    input-class="popup-postcode__input"
                    error-class="form-control-error-message"
                    type="number"
                    placeholder="Type in postcode..."
                  />
                </div>
              </div>
              <div className="popup-postcode__form-row">
                <button className="popup-postcode__button" onClick={handleSetLocation}>
                  Set As My Location
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default PostCodeUpdate;

